//@flow
import Markdown from 'react-markdown';
import React from 'react';

import EditButton from '../../NewEditButton';
import { componentNames as editorNames } from '../../TrekOverviewModal';

import './markdownViewer.css';

type Props = {
  description: string,
};

const openInNewTab = () => '_blank';

const DescriptionViewer = ({ description }: Props) => (
  <div>
    <h2>
      DESCRIPTION
      <span>
        <EditButton editorName={editorNames.DescriptionEditor} openModal={false} />
      </span>
    </h2>

    {description && (
      <p>
        <Markdown
          source={description}
          linkTarget={openInNewTab}
          className="markdown-viewer"
        />
      </p>
    )}
  </div>
);

export default DescriptionViewer;



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Viewers/Description/Description.jsx